import { AquatecSystemApiEnum } from 'submodules/nerit-aquatec-sdk/common/AquatecSystemApiEnum'
import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { ParameterGridRequestDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-control/dtos/requests/ParameterGridRequestDTO'
import { AnalysisNoteSaveRequestDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-control/dtos/requests/AnalysisNoteSaveRequestDTO'
import { ParameterGridResponseDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-control/dtos/responses/ParameterGridResponseDTO'

export class ParameterControlRequests {

	public static CONTROLLER_ROOT = 'parameter-control'
	public static GRID_EP = 'grid'
	public static SAVE_NOTE_EP = 'save-note'

	static grid = (dto: ParameterGridRequestDTO): RequestConfigTP<ParameterGridResponseDTO> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterControlRequests.CONTROLLER_ROOT}/${ParameterControlRequests.GRID_EP}`,
		method: HttpMethodEnum.GET,
		params: dto,
	})

	static saveNote = (dto: AnalysisNoteSaveRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterControlRequests.CONTROLLER_ROOT}/${ParameterControlRequests.SAVE_NOTE_EP}`,
		method: HttpMethodEnum.PUT,
		params: dto,
	})

}
